import { render, staticRenderFns } from "./LayoutNavigation.vue?vue&type=template&id=ba53cf04&scoped=true&"
var script = {}
import style0 from "./LayoutNavigation.vue?vue&type=style&index=0&id=ba53cf04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_css-loader@6.8.1_lodash@4.17.21_prettier@3.0.3_r_gaeimbjcwu57yzcey4waijeptq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba53cf04",
  null
  
)

export default component.exports